import axios from 'axios';
import { apiUrl } from './envURLConfig';

const http = axios.create({
  baseURL: apiUrl,
  crossdomain: true,
  // timeout: 30000,
  headers: {
    "Content-Type": "application/json"
  }
});
export default http;
